/* eslint-disable no-unused-vars */
import React from 'react';
import { Paper, Tooltip, Typography, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { customTheme } from '../customTheme';
// import { vehicleSvgs } from "../sharedData";
import Skeleton from '@material-ui/lab/Skeleton';
//import Chart from "react-apexcharts";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReactApexChart from 'react-apexcharts';
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { vehicleSvgs } from "../sharedData";


const useStyles = makeStyles({
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightMedium
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    flexContainer: {
        display: 'flex',
        alignItems:"center",
    },
    summaryVehicleIcon: {
        width: 18,
        height: 18,
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 13
    }
});

const donutColors = ['#16CC69', '#5E8DD3', '#5E8DD3', '#3EF791', '#FFCBA5', '#FFA7A6', '#92EEFC', '#5E8DD3', '#FFA726']


export default function VehicleSummaryCard({ title, loading, data, getValue, getDistributedValues,getAmount, getDistributedAmount, getDistributedLabels, getDistributedIcons, showDonutChart}) {
    const classes = useStyles();

    return <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px", }}>
                    <div style={{ flex: 1 }}>
                        <div>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography className={classes.title}>{title}</Typography>
                            </div>
                            {
                                !loading && data ?
                                    <div style={{ display: "flex" }}>
                                        <Typography className={classes.mainValue} style={{ color: "#334D6E"}}>{getValue(data)}</Typography>
                                        {getAmount && getAmount(data) && <Typography className={classes.mainValue} style={{ color: "#18CC69", marginLeft: 10 }}>{getAmount(data)}</Typography>}
                                    </div>
                                    :
                                    <Skeleton variant="text" height={42} width="34%" />
                            }
                        </div>
                        {
                            !loading && data ? getDistributedLabels(data).map((dL, i) => (
                                <div key={dL} className={classes.flexContainer}>
                                    <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center", flexGrow: 1}}>
                                    <img className={classes.summaryVehicleIcon} src={getDistributedIcons(data)[i]} alt={dL} />
                                    <Typography className={classes.summaryBoxLabel1} style={{ marginRight: 12 }}>{dL}:</Typography>
                                    </div>
                                    <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                    <Typography className={classes.summaryBoxValue1}>{getDistributedValues(data)[i]}</Typography>
                                    {getDistributedAmount && getDistributedAmount(data) && <>
                                <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69"}}>₹ {getDistributedAmount(data)[i] ? getDistributedAmount(data)[i].toFixed(2): 0}</Typography>                            </>
                            }
                                    </div>
                                        
                                </div>
                            )) :
                                ["50%", "40%"].map((width, index) => (
                                    <Skeleton variant="text" width={width} height={18} key={index} />
                                ))
                        }
                    </div>

                    {!loading && data && showDonutChart && 
                    <ReactApexChart
                    series={getDistributedValues(data)}
                    type="donut" 
                    width={120}
                    height={120}
                    options={{
                        labels: getDistributedLabels(data),
                        colors: donutColors,
                        chart: {
                            width: 120,
                            height: 120,
                            type: 'donut',
                          },
                          dataLabels: {
                            enabled: false
                          },
                        legend: {
                            show:false
                        },
                        responsive: [{
                          breakpoint: 480,
                          options: {
                            chart: {
                              width: 100
                            },
                            legend: {
                              position: 'bottom'
                            }
                          }
                        }]
                      }}
                />
                    }
                </Paper>

}